import React from 'react';
import { GraduationCap } from 'lucide-react';
import { StudentDropdown } from '../../StudentDropdown';
import { DebugOptionsTools } from '../../DebugOptionsTools';
import { useUserRole } from '../../../../hooks/useUserRole';
import { messages } from '../constants';

interface LessonsPageHeaderProps {
    /** Plan page main title (e.g. "{FirstName}'s Plan"). Defaults to "Plan". */
    planTitle?: string;
}

export function LessonsPageHeader({ planTitle }: LessonsPageHeaderProps = {}) {
    const { hasDeveloperOptionsPermission } = useUserRole();

    const displayTitle = planTitle ?? messages.pageTitle;

    const showDebugOptions = hasDeveloperOptionsPermission;

    return (
        <div className="flex items-center justify-between mb-6">
            <div className="flex items-center">
                <GraduationCap className="mr-3 text-action-blue" size={24}/>
                <h1 className="text-2xl font-bold text-gray-900">{displayTitle}</h1>
            </div>
            <div className="flex items-center gap-2">
                <StudentDropdown dataTour="plan-student-selector" />
                {showDebugOptions && <DebugOptionsTools />}
            </div>
        </div>
    );
}
